
import { filter } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';
import { WirePageBuilderService } from '../../../services/wire-page-builder.service';
import { Subscription } from 'rxjs';
import { WireService } from '../../../services/wire.service';

@Component({
    selector: 'agpr-wire-composition-report',
    templateUrl: './wire-composition-report.component.html',
    styleUrls: ['./wire-composition-report.component.scss'],
    standalone: false
})
export class WireCompositionReportComponent implements OnDestroy {

    companyLogoHtml: string = '';
    bodyHtml: string = '';
    headerHtml: string = '';
    logoHtml: string = '';

    subscriptions: Subscription[] = [];

    constructor(
        public wireService: WireService,
        public wirePageBuilderService: WirePageBuilderService
    ) {
        this.subscriptions.push(
            this.wireService.currentResource$.pipe(filter(x => !!x)).subscribe(wire => {
                const doc = new DOMParser().parseFromString(wire.bodyHtml, 'text/html');
                const preBodyBlocks = Array.from(doc.querySelectorAll('[id^="preBody"]'));
                const companyLogoBlock = preBodyBlocks.find(element => element.id === 'preBody.companyLogo');
                if (companyLogoBlock) {
                    this.companyLogoHtml = companyLogoBlock.outerHTML;
                }
                preBodyBlocks.forEach(element => {
                    element.remove();
                });
                this.bodyHtml = doc.documentElement.outerHTML;
                this.headerHtml = this.wirePageBuilderService.getWireHeaderHtml();
                this.logoHtml = this.wirePageBuilderService.getCompanyLogoHtml();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
